import { SampleRelatedRecords } from './types';

// Made-up emails and attachments for the Related tab until it reads them from Salesforce.
export const SAMPLE_RELATED_RECORDS: SampleRelatedRecords = {
  emails: [
    {
      subject: 'RE: Card overcharge - 100000001 - Example Payments',
      from: 'pat.example@example.com',
      to: 'alex.sample@example.com; finance.team@example.com',
      date: '25/09/2026 7:03 PM',
    },
  ],
  attachments: [
    { name: 'screenshot-1.png', date: '25/09/2026' },
    { name: 'screenshot-2.png', date: '25/09/2026' },
    { name: 'screenshot-3.png', date: '25/09/2026' },
  ],
};
